import { Table, Tag, Empty } from "antd";
import trans from "../../../utils";
import { formatDateString } from "../../../JsHelpers/DateFormat";

const TASK_STATUS_COLORS = {
  todo: "default",
  delayed: "orange",
  inProgress: "blue",
  done: "green",
  overDue: "red",
  cancelled: "red",
};

export default function ServiceRequestTasksTab({ tasks, loading, onSelectTask }) {
  const columns = [
    {
      title: trans("Task Code"),
      dataIndex: "code",
      key: "code",
      width: 130,
    },
    {
      title: trans("Assigned Technician"),
      key: "assignedTo",
      width: 180,
      render: (_, record) => record.assignedTo?.name || trans("Unassigned"),
    },
    {
      title: trans("Last Update"),
      dataIndex: "updatedAt",
      key: "updatedAt",
      width: 170,
      render: (v) => (v ? formatDateString(v) : "-"),
    },
    {
      title: trans("Current Status"),
      dataIndex: "status",
      key: "status",
      width: 140,
      render: (status) => (
        <Tag color={TASK_STATUS_COLORS[status] || "default"} className="text-capitalize">
          {trans(status)}
        </Tag>
      ),
    },
  ];

  return (
    <Table
      rowKey="id"
      columns={columns}
      dataSource={tasks || []}
      loading={loading}
      pagination={false}
      scroll={{ x: "max-content" }}
      locale={{
        emptyText: <Empty description={trans("No related tasks found")} />,
      }}
      onRow={(record) => ({
        onClick: () => onSelectTask(record.id),
        style: { cursor: "pointer" },
      })}
    />
  );
}
